import React, { useState, useEffect, useRef } from "react";
import { Badge, Breadcrumb, Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Tab, Tabs } from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FilesCreate from "../file/FilesCreate";
import RelatedListFiles from "../file/RelatedListFiles";
import Path from "../common/Path";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import PubSub from "pubsub-js";
import Chat from "../common/Chat";
import RelatedListTask from "../task/RelatedListTask";
import { ROUTES } from "../../constants/webRouting";
import { formatDate, formatDateForCreatedDate, getUserDetails, formatDateForView } from "../../utils/helper";
import { getLoggedInUserEmail } from "../../utils/auth";
import { generateQuotationPdf } from "../../utils/quotationPdfGenerator";
import TaskEdit from "../task/TaskEdit";
import RelatedListOrder from "../order/RelatedListOrder";
import RelatedListQuotationDetails from "./RelatedListQuotationDetails";
import PERMISSIONS from "../../constants/permissions";

const OfferView = () => {
    const userInfo = getUserDetails();
    const userEmail = getLoggedInUserEmail();
    const isAuthorized = userEmail === "farhan@gmail.com";
    const location = useLocation();
    const navigate = useNavigate();
    const pdfContent = useRef(null);
    // console.log('state',location.state);
    const [offer, setOffer] = useState(location.state ? location.state : {});
    // console.log('offer', offer);

    const [data, setData] = useState([]);

    const [modalShow, setModalShow] = useState(false);
    const [imageData, setImageData] = useState();
    const [modalShowFile, setModalShowFile] = useState(false);
    const [modalShowTask, setModalShowTask] = useState(false);

    const [refreshFileList, setRefreshFileList] = useState(false);
    const [refreshTaskList, setRefreshTaskList] = useState();
    const [refreshOrderList, setRefreshOrderList] = useState();
    const [refreshQuotationList, setRefreshQuotationList] = useState();

    const [relatedListFiles, setRelatedListFiles] = useState(true);
    const [relatedListTaskList, setRelatedListTask] = useState(false);
    const [relatedListOrder, setRelatedListOrder] = useState(false);
    const [relatedListQuotation, setRelatedListQuotation] = useState(false);

    const [convertShow, setConvertShow] = useState(true);

    const [showDetails, setShowDetails] = useState(true);
    const [showNotesMessages, setShowNotesMessages] = useState(false);

    const [editDisable, setDisableEdit] = useState(true);
    const [payments, setPayments] = useState({});
    // const [updateCounter, setUpdateCounter] = useState(0);

    const [generatingQuotation, setGeneratingQuotation] = useState(false);

    const [leadStatusArray, setleadStatusArray] = useState(
        constants.OFFER_STATUS_VALUES
    );

    const [proejectTotal, setTotalAmountProject] = useState({});
    const [accounts, setAccounts] = useState([]);//Added by shahir hussain AMC 1002
    // Function to get account name by id - Added by Imran Khan 04-02-2026
    const getAccountName = (id) => {
        if (!id || !accounts?.length) return "";
            return accounts.find(a => String(a.id) === String(id))?.name || "";
    };

    useEffect(() => {
        fetchOffer();
        // (userInfoJWT.id === offer.owner_id) && setDisableEdit(false);

    }, []);

    const fetchOffer = () => {
        if (
            !offer.id &&
            location.hasOwnProperty("pathname") &&
            location.pathname.split("/").length >= 3
        ) {
            offer.id = location.pathname.split("/")[2];
        }

        async function init() {
            let result = await fuziElevatorsApi.fetchOfferById(offer.id);
            if (result) {
                setOffer(result);
                setData(result);
            } else {
            }

            //Added by shahir hussain AMC 1002 - 11-12-2025
            const resultedAccounts = await fuziElevatorsApi.fetchAccounts();
            resultedAccounts && Array.isArray(resultedAccounts) && setAccounts(resultedAccounts);
        }
        init();
    };

    const deleteOffer = async () => {
        const result = await fuziElevatorsApi.deleteOfferById(offer.id);

        if (result?.success) {
            PubSub.publish("RECORD_SAVED_TOAST", {
                title: "Deleted",
                message: "Record Deleted successfully",
            });
        } else {
            PubSub.publish("RECORD_ERROR_TOAST", {
                title: "Record update Error",
                message: result?.errors,
            });
        }
        navigate(ROUTES.OFFER.LIST);
    };

    const edit = () => {
        navigate(`${ROUTES.OFFER.LIST}/${offer.id}/e`, { state: offer });
    };

    const handleGenerateQuotation = async () => {
        if (!offer?.id) return;
        setGeneratingQuotation(true);
        try {
            const result = await fuziElevatorsApi.generateOfferQuotation(offer.id);
            if (result?.success) {
                PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Success",
                    message: "Quotation generated successfully",
                });
                fetchOffer();
                setRefreshQuotationList((prev) => !prev);
                try {
                    await generateQuotationPdf(
                        offer,
                        result.quotation_items,
                        result.quotation_summary
                    );
                } catch (pdfErr) {
                    console.warn("Quotation PDF download failed:", pdfErr);
                }
            } else {
                const errMsg = Array.isArray(result?.errors)
                    ? result.errors.map((e) => e?.msg || e?.message).join(", ")
                    : result?.errors || "Failed to generate quotation";
                PubSub.publish("RECORD_ERROR_TOAST", {
                    title: "Error",
                    message: errMsg,
                });
            }
        } catch (err) {
            PubSub.publish("RECORD_ERROR_TOAST", {
                title: "Error",
                message: err?.message || "Failed to generate quotation",
            });
        } finally {
            setGeneratingQuotation(false);
        }
    };

    const handleRelatedListTab = (key) => {
        if (key === "files") {
            setRelatedListFiles(true);
            setRelatedListTask(false);
            setRelatedListOrder(false);
            setRelatedListQuotation(false);
        } else if (key === "tasks") {
            setRelatedListFiles(false);
            setRelatedListTask(true);
            setRelatedListOrder(false);
            setRelatedListQuotation(false);
        } else if (key === "orders") {
            setRelatedListFiles(false);
            setRelatedListTask(false);
            setRelatedListOrder(true);
            setRelatedListQuotation(false);
        } else if (key === "quotation") {
            setRelatedListFiles(false);
            setRelatedListTask(false);
            setRelatedListOrder(false);
            setRelatedListQuotation(true);
        }
    };

    const handleTab = (key) => {
        if (key === "details") {
            setShowDetails(true);
            setShowNotesMessages(false);
        } else if (key === "notesMessages") {
            setShowDetails(false);
            setShowNotesMessages(true);
        }
    };

    const submitFiles = () => {
        setModalShowFile(false);
        setRefreshFileList(Date.now());
        // setModalShowTask(false);
        fetchOffer();
    };

    const submitTasks = () => {
        setModalShowTask(false);
        setRefreshTaskList((prev) => !prev);
    };

    //Imran Khan 29-01-2026
    const showDoorConfig =
        offer?.all_doors_same === "DIFFERENT" &&
        offer?.total_stops != null &&
        offer?.number_of_openings != null &&
        Number(offer.total_stops) !== Number(offer.number_of_openings);


    // Find the current status' sortorder
    //  const currentStatus = leadStatusArray.find(status => status.sortorder === offer.leadstatus);
    //   console.log("leadStatusArray", leadStatusArray);

    // Checking Lead Status array vallue and shwoing as till length as higlighted.
    const highlightedStatusArray = leadStatusArray.map((status) => ({
        ...status,
        highlight: status.sortorder <= offer.lead_status,
    }));

    //   const [currentRec, setCurrentRecord] = useState({});
    //   const [locationRecordv1, setLocationRecordv1] = useState({});
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [address, setAddress] = useState(`${offer.site_address}`); // Default address

    useEffect(() => {
        const loadGoogleMapsScript = () => {
            if (!window.google) {
                const googleMapScript = document.createElement("script");
                googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtztwOW6bufAlbBWfO1k5FdZTkpUP_gmI&callback=initMap`;
                googleMapScript.async = true;
                googleMapScript.defer = true;
                googleMapScript && window.document.body.appendChild(googleMapScript);
            } else {
                window.initMap();
            }
        };

        window.initMap = () => {
            myMapFunction();
        };

        loadGoogleMapsScript();
    }, [latitude, longitude, address]);

    const myMapFunction = async () => {
        if (!latitude || !longitude) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: address }, (results, status) => {
                if (status === "OK") {
                    const location = results[0].geometry.location;
                    setLatitude(location.lat());
                    setLongitude(location.lng());

                    const mapProp = {
                        center: location,
                        zoom: 14,
                    };

                    const map = new window.google.maps.Map(
                        document.getElementById("googleMapaddress"),
                        mapProp
                    );

                    const marker = new window.google.maps.Marker({
                        map,
                        position: location,
                        title: results[0].formatted_address,
                    });

                    const infowindow = new window.google.maps.InfoWindow({
                        content: results[0].formatted_address,
                    });

                    marker.addListener("click", () => {
                        infowindow.open(map, marker);
                    });

                    setAddress(results[0].formatted_address);
                } else {
                    console.error(
                        "Geocode was not successful for the following reason: " + status
                    );
                }
            });
        } else {
            const location = new window.google.maps.LatLng(latitude, longitude);
            const mapProp = {
                center: location,
                zoom: 14,
            };

            const map = new window.google.maps.Map(
                document.getElementById("googleMapaddress"),
                mapProp
            );

            const marker = new window.google.maps.Marker({
                map,
                position: location,
                title: address,
            });

            const infowindow = new window.google.maps.InfoWindow({
                content: address,
            });

            marker.addListener("click", () => {
                infowindow.open(map, marker);
            });
        }
    };

    return (
        <Container className="pb-5">
            {offer && (
                <>
                    {modalShow && (
                        <Confirm
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            deleteOffer={deleteOffer}
                            title="Confirm delete?"
                            message="You are going to delete the record. Are you sure?"
                            table="offer"
                        />
                    )}

                    <Row className="view-form   mx-auto">
                        <Col md={12} className="">
                            <Breadcrumb>
                                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                                    Home
                                </Breadcrumb.Item>
                                <Breadcrumb.Item onClick={() => navigate(ROUTES.OFFER.LIST)}>
                                    Offers
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>

                        <Col lg={12} className="">
                            <Container className="pb-3 sticky-card-header-view">
                                <Row className="view-form-header-lead bg-custom align-items-center rounded  ">
                                    <Col lg={8}>
                                        <h6 className="m-0 ">Offer</h6>
                                        <h4 className="m-0 ">{offer?.offer_name || ""}</h4>
                                    </Col>
                                    <Col lg={4} className="d-flex justify-content-end gap-3">

                                        {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_OFFER].some(permission => {
                                            return userInfo?.permissions?.map(p => p.name).includes(permission);
                                        })
                                            && (
                                                <Button
                                                    size="sm"
                                                    className="btn-edit"
                                                    onClick={() => edit(true)}
                                                >
                                                    <i className="fa-regular fa-pen-to-square"></i>
                                                </Button>)
                                        }

                                        {isAuthorized &&
                                        offer?.offer_status !== "Order Received" &&
                                        [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_OFFER].some(permission =>
                                            userInfo?.permissions?.map(p => p.name).includes(permission)
                                        ) && (
                                            <Button
                                                size="sm"
                                                variant="success"
                                                onClick={handleGenerateQuotation}
                                                disabled={generatingQuotation}
                                            >
                                                {generatingQuotation ? (
                                                    <><Spinner animation="border" size="sm" className="me-1" />Generating...</>
                                                ) : (
                                                    <>Generate Quotation</>
                                                )}
                                            </Button>
                                        )}

                                        {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_OFFER].some(permission => {
                                            return userInfo?.permissions?.map(p => p.name).includes(permission);
                                        }) && (
                                                <Button
                                                    size="sm"
                                                    className="btn-delete"
                                                    onClick={() => setModalShow(true)}
                                                >
                                                    <i className="fa fa-trash-o"></i>
                                                </Button>)
                                        }
                                    </Col>
                                </Row>
                            </Container>
                            <Card>
                                <CardHeader className="sticky-tabs-header">
                                    <Col lg={12} className="mt-4" style={{ color: "#fff" }}>
                                        <Tabs
                                            defaultActiveKey="details"
                                            id="uncontrolled-tab-example"
                                            onSelect={(key) => handleTab(key)}
                                            style={{ marginBottom: "12px" }}
                                        >
                                            <Tab eventKey="details" title="Details"></Tab>
                                            <Tab
                                                eventKey="notesMessages"
                                                title="Notes & Messages"
                                            ></Tab>
                                        </Tabs>
                                    </Col>
                                </CardHeader>

                                <CardBody className="card-body-scroll">
                                    <Container>
                                        {showDetails && (
                                            <Row className="">
                                                <Col lg={12}>
                                                    <div className="scrollable-container">
                                                        <Path
                                                            values={highlightedStatusArray}
                                                            selectedValue={offer?.offer_status}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col lg={6}>
                                                    <label>Enquiry No</label>
                                                    <span>{offer?.enquiry_no}</span>
                                                </Col>

                                                <Col lg={6}>
                                                    <label>Job Number</label>
                                                    <span>{offer?.job_no || ""}</span>
                                                </Col>
                                                <Col lg={6}>
                                                    <label>Lead Name</label>
                                                    <span>{offer?.lead_name}</span>
                                                </Col>
                                                <Col lg={6}>
                                                    <label>Offer Name</label>
                                                    <span>{offer?.offer_name || ""}</span>
                                                </Col>
                                                {/* formatDateForView added by shahir hussain 27-08-2025 */}
                                                <Col lg={6}>
                                                    <label>offer Date</label>
                                                    <span>{formatDateForView(offer?.offer_date)}</span>
                                                </Col>
                                                <Col lg={6}>
                                                    <label>Offer Status</label>
                                                    <span>{offer?.offer_status}</span>
                                                </Col>

                                                {/* {offer?.offer_status === 'Order Lost' &&
                                                    <>
                                                        <Col lg={6}>
                                                            <label>Lost Date</label>
                                                            <span>{offer?.is_lost_date ? formatDateForCreatedDate(offer?.is_lost_date) : ''}</span>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <label>Lost Reason</label>
                                                            <span>{offer?.is_lost_remark || ''}</span>
                                                        </Col>
                                                    </>
                                                } */}
                                                <Col lg={6}>
                                                    <label>Email</label>
                                                    <span>{offer?.email || ""}</span>
                                                </Col>
                                                <Col lg={6}>
                                                    <label>Phone</label>
                                                    <span>{offer?.phone || ""}</span>
                                                </Col>
                                                <Col lg={6}>
                                                    <label>WhatsApp Number</label>
                                                    <span>{offer?.whatsapp_no || ""}</span>
                                                </Col>
                                                <Col lg={6}>
                                                    <label>Telephone Number</label>
                                                    <span>{offer?.tel_no || ""}</span>
                                                </Col>

                                                <Col lg={6}>
                                                    <label>Date of Birth</label>
                                                    <span>{formatDateForView(offer?.date_of_birth || "")}</span>
                                                </Col>

                                                <Col lg={6}>
                                                    <label>Anniversary Date</label>
                                                    <span>{formatDateForView(offer?.anniversary_date || "")}</span>
                                                </Col>

                                                {/* <Col lg={6}>
                                                    <label>Assigned User</label>
                                                    <span>
                                                         
                                                        <img
                                                            src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                                                            className="rounded-circle"
                                                            style={{
                                                                height: "30px",
                                                                width: "30px",
                                                                objectFit: "cover",
                                                            }}
                                                            alt=""
                                                        />
                                                        <img
                                                            src={localStorage.getItem("myimage")}
                                                            className="rounded-circle"
                                                            style={{ height: "30px" }}
                                                            alt=""
                                                        />

                                                        <Badge
                                                            bg="warning"
                                                            className="mx-2"
                                                            style={{ display: "inline", color: "#000" }}
                                                        >
                                                            {offer?.owner_name || ""}
                                                        </Badge>
                                                    </span>
                                                </Col> */}

                                                <Col lg={6}>
                                                    <label>Assigned Users</label>
                                                    <span>
                                                        <div className="d-flex flex-wrap gap-1">
                                                            {offer?.owner_ids?.map((item) =>
                                                                <Badge
                                                                    bg="warning"
                                                                >
                                                                    <Link to={`${ROUTES.USER.LIST}/${item.value}`} className="text-decoration-none text-dark fw-bold">
                                                                        {item.label}
                                                                    </Link>
                                                                </Badge>
                                                            )}
                                                        </div>
                                                    </span>
                                                </Col>

                                                <Col lg={6}>
                                                    <label>Created Date</label>
                                                    <span>
                                                        {formatDateForView(offer?.createddate || "")}
                                                    </span>
                                                </Col>

                                                <>
                                                    <Col lg={12} className="section-header">
                                                        SERVICE INFORMATION
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Product</label>
                                                        <span>{offer?.product_name || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Make</label>
                                                        {/* <span>{offer.accounts?.map((item) => item.label)?.join(',') || ''}</span> */}
                                                        <span>
                                                            {accounts
                                                                ?.filter(acc => offer?.account_id?.includes(acc.id))
                                                                ?.map(acc => acc.name)
                                                                ?.join(', ')
                                                            }
                                                        </span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Offer Remark</label>
                                                        <span>{offer?.offer_remark || ''}</span>
                                                    </Col>
                                                </>

                                                <>
                                                    <Col lg={12} className="section-header">
                                                        CUSTOMER INFORMATION
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Customer Type</label>
                                                        <span>{offer?.offer_type || ""}</span>
                                                    </Col>
                                                    {
                                                        offer?.offer_type == 'Corporate' &&
                                                        <Col lg={6}>
                                                            <label>Company Name</label>
                                                            <span>{offer?.company_name || ""}</span>
                                                        </Col>
                                                    }

                                                    <Col lg={6}>
                                                        <label>Sector</label>
                                                        <span>{offer?.sector || ""}</span>
                                                    </Col>
                                                    {/* Imran Khan Updated */}
                                                    <Col lg={6}>
                                                        <label>Is GST Applicable</label>
                                                        <span>{offer?.is_gst || "-"}</span>
                                                    </Col>
                                                    {offer?.is_gst === 'Yes' && <Col lg={6}>
                                                        <label>GST No</label>
                                                        <span>{offer?.gst_no}</span>
                                                    </Col>}
                                                    <Col lg={6}>
                                                        <label>Competitor Name</label>
                                                        <span>{offer?.competitor_name || ""}</span>
                                                    </Col>
                                                    {/* Add Segment Type by shahir hussain 02-02-2026 */}
                                                    <Col lg={6}>
                                                        <label>Segment Type</label>
                                                        <span>{offer?.segment || ""}</span>
                                                    </Col>
                                                </>

                                                <>
                                                    <Col lg={12} className="section-header">
                                                        OFFER INFORMATION
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Offer Rate</label>
                                                        <span>{offer?.highest_model_rate || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Number Of Units</label>
                                                        <span>{offer?.number_of_units || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Offer Amount</label>
                                                        <span>{offer?.offer_amount || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Passenger Capacity</label>
                                                        <span>{offer?.passenger_capacity || ""}</span>
                                                    </Col>
                                                    {/* <Col lg={6}>
                                                        <label>Elevator Type</label>
                                                        <span>{offer?.elevator_type ?? ""}</span>
                                                    </Col>

                                                    <Col lg={6}>
                                                        <label>Elevator Capacity</label>
                                                        <span>
                                                            {offer?.elevator_capacity
                                                            ? `${offer.elevator_capacity} ${offer?.elevator_unit || ""}`
                                                            : ""}
                                                        </span>
                                                    </Col> */}
                                                    <Col lg={6}>
                                                        <label>Elevator Type</label>
                                                        <span>{offer?.elevator_type ?? ""}</span>
                                                    </Col>

                                                    <Col lg={6}>
                                                        <label>Elevator Capacity</label>
                                                        <span>
                                                            {offer?.elevator_capacity
                                                            ? `${offer.elevator_capacity} ${
                                                                offer.elevator_type === "Passenger"
                                                                    ? "Passenger"
                                                                    : offer.elevator_type === "Hospital"
                                                                    ? offer.elevator_capacity === 15
                                                                    ? "Passenger cum Stretcher"
                                                                    : "Passenger cum Bed"
                                                                    : "Kg"
                                                                }`
                                                            : ""}
                                                        </span>
                                                    </Col>

                                                    <Col lg={6}>
                                                        <label>Stops</label>
                                                        <span>{offer?.stops ?? offer?.total_stops ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Travel Distance</label>
                                                        <span>{offer?.travel_distance ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Total Number Of Stop</label>
                                                        <span>{offer?.total_stops || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Number Of Opening</label>
                                                        <span>{offer?.number_of_openings || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Name Of Different Floor</label>
                                                        <span>{offer?.floor_name || ""}</span>
                                                    </Col>
                               
                                                    <Col lg={6}>
                                                        <label>Floor Counts</label>
                                                        <span>{offer?.floor_counts || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Motor Type</label>
                                                        <span>{offer?.motor || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Lift Type</label>
                                                        <span>{offer?.lift_type ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Lift Speed</label>
                                                        <span>{offer?.lift_speed ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Speed</label>
                                                        <span>{offer?.speed ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Machine Type</label>
                                                        <span>{offer?.machine_type ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Car Construction</label>
                                                        <span>{offer?.car_construction ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Door Construction</label>
                                                        <span>{offer?.door_construction ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Door Type</label>
                                                        <span>{offer?.door_type ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Motor Make</label>
                                                        <span>{getAccountName(offer?.motor_make_id)}</span>
                                                    </Col>
                                                    {/* Added by Imran Khan 27-01-2026 */}
                                                    <Col lg={6}>
                                                        <label>Motor Model No.</label>
                                                        <span>{offer?.motor_model_no || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Motor KW</label>
                                                        <span>{offer?.motor_kw || ""} {offer?.motor_kw ? <>KW</> : ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Motor AMP</label>
                                                        <span>{offer?.motor_amp || ""} {offer?.motor_amp ? <>AMP</> : ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Lift Will Be Run</label>
                                                        <span>{offer?.lift_run_phase || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Drive Type</label>
                                                        <span>{offer?.drive_type || ""}</span>
                                                    </Col>
                                                    {/* <Col lg={6}>
                                                        <label>Motor Make</label>
                                                        <span>
                                                            {accounts?.find(a => a.id === offer?.motor_make_id)?.name || "-"}
                                                        </span>
                                                    </Col> */}
                                                    {/* Motor Make Added by Imran Khan 04-02-2026 */}
                                                   

                                                    {/* Updated by Imran Khan 29-01-2026 for Door Opening Dropdown */}
                                                    <Col lg={6}>
                                                        <label>Door Opening</label>
                                                        <span>
                                                            {offer?.door_opening
                                                            ? offer.door_opening
                                                                .split(",")
                                                                .map(v => {
                                                                    if (v === "CENTER") return "Center Opening";
                                                                    if (v === "SIDE_LEFT") return "Side Opening – Left";
                                                                    if (v === "SIDE_RIGHT") return "Side Opening – Right";
                                                                    if (v === "SIDE") return "Side Opening";
                                                                    return "";
                                                                })
                                                                .filter(Boolean)
                                                                .join(", ")
                                                            : ""}
                                                        </span>
                                                    </Col>
                                                    {/* End Updated by Imran Khan 29-01-2026 for Door Opening Dropdown */}
                                                    <Col lg={6}>
                                                        <label>All Doors Same</label>
                                                        <span>{offer?.all_doors_same ?? ""}</span>
                                                    </Col>
                                                    {/* Imran Khan Added Door Configuration Section on 28/01/2026 */}
                                                    {showDoorConfig && (
                                                    <>
                                                        <Col lg={6}>
                                                            <label>Any Floor Both Side</label>
                                                            <span>{offer?.both_side_floor ?? ""}</span>
                                                        </Col>

                                                        <Col lg={6}>
                                                            <label>Reverse Opening Floor</label>
                                                            <span>{offer?.reverse_opening_floor ?? ""}</span>
                                                        </Col>

                                                        <Col lg={6}>
                                                            <label>Side Opening Floor</label>
                                                            <span>{offer?.side_opening_floor ?? ""}</span>
                                                        </Col>
                                                    </>
                                                    )}
                                                   
                                                    <Col lg={6}>    
                                                        <label>Door Vision</label>
                                                        <span>{offer?.door_vision || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Door Make</label>
                                                        <span>{getAccountName(offer?.door_make_id)}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Available Shaft Size</label>
                                                        <span>{offer?.available_shaft_size || ""} </span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Shaft Width</label>
                                                        <span>{offer?.shaft_min || ""} {offer?.shaft_min ? <>MM</> : ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Shaft Depth</label>
                                                        <span>{offer?.shaft_max || ""} {offer?.shaft_max ? <>MM</> : ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Car Internal Size</label>
                                                        <span>{offer?.available_car_size || ""} </span>
                                                   </Col>
                                                    <Col lg={6}>
                                                        <label>Car Internal Width</label>
                                                        <span>{offer?.car_internal_min || ""} {offer?.car_internal_min ? <>MM</> : ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Car Internal Depth</label>
                                                        <span>{offer?.car_internal_max || ""} {offer?.car_internal_max ? <>MM</> : ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Door Size</label>
                                                        <span>{offer?.door_size || ""} </span>
                                                   </Col>
                                                    <Col lg={6}>
                                                        <label>Door Width</label>
                                                        <span>{offer?.door_min || ""} {offer?.door_min ? <>MM</> : ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Door Height</label>
                                                        <span>{offer?.door_max || ""} {offer?.door_max ? <>MM</> : ""}</span>
                                                    </Col>
                                                   
                                                    <Col lg={6}>
                                                        <label>Metal of Door</label>
                                                        <span>{offer?.door_metal || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Finish</label>
                                                        <span>{offer?.metal_finish ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Control Panel Make</label>
                                                        <span>{getAccountName(offer?.control_panel_make_id)}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Operation</label>
                                                        <span>{offer?.operation || ""}</span>
                                                    </Col>
                                               
                                                    <Col lg={6}>
                                                        <label>Lift Type</label>
                                                        <span>{offer?.lift_drive_type || ""}</span>
                                                    </Col>

                                                        <Col lg={6}>
                                                            <label>Lift Pit</label>
                                                            <span>
                                                                {offer?.lift_pit === "NO_PIT"
                                                                ? "No pit required"
                                                                : offer?.lift_pit
                                                                ? `${offer.lift_pit} mm`
                                                                : ""}
                                                            </span>
                                                        </Col>

                                                        <Col lg={6}>
                                                            <label>Lift Overhead</label>
                                                            <span>
                                                                {offer?.lift_overhead
                                                                ? isNaN(offer.lift_overhead)
                                                                    ? offer.lift_overhead
                                                                    : `${offer.lift_overhead} mm`
                                                                : ""}
                                                            </span>
                                                        </Col>
                                                    {/* Imran Khan Added Cabin Wall Material, Cabin Wall Finish, Cabin Ceiling Material, Cabin Ceiling Finish and Cabin Light Type on 28/01/2026 */}
                                                    <Col lg={6}>
                                                        <label>Cabin Walls</label>
                                                        <span>
                                                            {offer?.cabin_wall_material}  {offer?.cabin_wall_finish}
                                                        </span>
                                                    </Col>

                                                    <Col lg={6}>
                                                        <label>Cabin Ceiling</label>
                                                        <span>
                                                            {offer?.cabin_ceiling_material}  {offer?.cabin_ceiling_finish}
                                                        </span>
                                                    </Col>

                                                    <Col lg={6}>
                                                        <label>Cabin Light</label>
                                                        <span>{offer?.cabin_light_type}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Fan</label>
                                                        <span>{offer?.fan || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Blower</label>
                                                        <span>{offer?.blower || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>  
                                                        <label>Handrail Shape</label>
                                                        <span>{offer?.handrail_shape || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Handrail Finish</label>
                                                        <span>
                                                            {offer?.handrail_material || ""}{" "}
                                                            {offer?.handrail_finish || ""}
                                                        </span>
                                                    </Col>

                                                    {/* End Added by Imran Khan 28-01-2026 */}
                                                    <Col lg={6}>    
                                                        <label>Flooring</label>
                                                        <span>{offer?.flooring || ""}</span>    
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Pit Size</label>
                                                        <span>{offer?.pit_size ?? ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Guiderail Qty</label>
                                                        <span>{offer?.guiderail_qty ?? ""}</span>
                                                    </Col>
                                                    {/* Imran Khan Added Floor Type Dropdown on 05/02/2026 */}
                                                    <Col lg={6}>    
                                                        <label>Panel Type</label>
                                                        <span>{offer?.cop_panel_type || ""}</span>    
                                                    </Col>

                                                    <Col lg={6}>    
                                                        <label>Button Type</label>
                                                        <span>{offer?.cop_button_type || ""}</span>    
                                                    </Col>

                                                    <Col lg={6}>    
                                                        <label>Display Type</label>
                                                        <span>{offer?.cop_display || ""}</span>    
                                                    </Col>
                                                    {/* Imran Khan Added Car operating on 29/01/2026 */}
                                                    <Col lg={6}>
                                                        <label>Car Operating Panel</label>
                                                        <span>
                                                            {offer?.cop_finish
                                                            ? `${offer.cop_finish} ${offer?.cop_braille === "Yes" ? "(With Braille)" : ""}`
                                                            : ""}
                                                        </span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Landing Panel Type</label>
                                                        <span>{offer?.lop_panel_type || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Landing Button Type</label>
                                                        <span>{offer?.lop_button_type || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Landing Display Type</label>
                                                        <span>{offer?.lop_display || ""}</span>
                                                    </Col>
                                                    {/* Imran Khan Added All Landing panel 04/02/2026 */}
                                                    <Col lg={6}>
                                                        <label>All Landing Operating Panel</label>
                                                        <span>
                                                            {offer?.all_landing_op_finish
                                                            ? `${offer.all_landing_op_finish}${
                                                                offer?.all_landing_op_braille === "Yes"
                                                                    ? " (With Braille)"
                                                                    : ""
                                                                }`
                                                            : ""}
                                                        </span>
                                                    </Col>

                                                    {/* End Imran Khan */}
                                                    <Col lg={6}>
                                                        <label>Door Panels</label>
                                                        <span>{offer?.door_panels || ""}</span>
                                                    </Col>
                                                    {/* Imran Khan Added Machine Room Dropdown on 28/01/2026 */}
                                                   <Col lg={6}>
                                                        <label>Machine Room</label>
                                                        <span>{offer?.machine_room || ""}</span>
                                                    </Col>
                                                    {offer?.machine_room === "Yes" && (
                                                        <Col lg={6}>
                                                            <label>Machine Room Height</label>
                                                            <span>
                                                            {offer?.machine_room_height
                                                                ? `${offer.machine_room_height} mm`
                                                                : "2000 mm"}
                                                            </span>
                                                        </Col>
                                                    )}
                                                    {/* End here Imran Khan */}
                                                    <Col lg={6}>
                                                        <label>Dlp Period</label>
                                                        <span>{offer?.dlp_period || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Brand Offered</label>
                                                        <span>{offer?.brand_offered || ""}</span>
                                                    </Col>

                                                    <Col lg={6}>
                                                        <label>Offer Side</label>
                                                        <span>{offer?.offer_side || ""}</span>
                                                    </Col>
                                                   
                                                    <Col lg={6}>
                                                        <label>Cabin Metal</label>
                                                        <span>{offer?.cabin_metal || ""}</span>
                                                    </Col>                          
                                                    <Col lg={6}>
                                                       <label>Shaft Construction</label>
                                                        <span>{offer?.shaft_construction || ""}</span>
                                                    </Col>                                                                                                    
                                                </>

                                                <>
                                                    <Col lg={12} className="section-header">
                                                        ADDRESS INFORMATION
                                                    </Col>

                                                    <Col lg={6}>
                                                        <label>Site Address</label>
                                                        <span>{offer?.site_address || ""}</span>
                                                    </Col>
                                                    {/* //Added by shahir hussain */}
                                                    <Col lg={6}>
                                                        <label>Area</label>
                                                        <span>{offer?.area || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>State</label>
                                                        <span>{offer?.state || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>City</label>
                                                        <span>{offer?.city || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Office Address</label>
                                                        <span>{offer?.office_address || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Office City</label>
                                                        <span>{offer?.office_city || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Pincode</label>
                                                        <span>{offer?.pincode || ""}</span>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label>Country</label>
                                                        <span>{offer?.country || ""}</span>
                                                    </Col>
                                                    <Col lg={12}>
                                                        <div
                                                            id="googleMapaddress"
                                                            className="my-2"
                                                            style={{
                                                                width: "100%",
                                                                height: "300px",
                                                                border: "1px solid black",
                                                            }}
                                                        ></div>
                                                    </Col>
                                                </>
                                                {/*Imran Khan Update Lead View page for Lost Offer Information*/}
                                                {
                                                    offer?.offer_status === 'Offer Lost' &&
                                                    <>
                                                        <Col lg={12} className="section-header">
                                                            Offer Lost  INFORMATION
                                                        </Col>
                                                        <Col lg={6}>
                                                            <label>Lost Date</label>
                                                            <span>{formatDateForCreatedDate(offer?.is_lost_date || "")}</span>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <label>Offer Lost Remark</label>
                                                            <span>{offer?.is_lost_remark}</span>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <label>Lost By (Company)</label>
                                                            <span>{offer?.lost_by_reason}</span>
                                                        </Col>
                                                    </>}
                                                {/*End Imran Khan Update offer View page for Enquiry Lost Offer Information*/}
                                            </Row>
                                        )}

                                        {showNotesMessages && (
                                            <Card className="mt-2">
                                                <Row className="mt-4">
                                                    <Col lg={12}>
                                                        <Chat parentid={offer?.id} />
                                                    </Col>
                                                </Row>
                                            </Card>
                                        )}
                                    </Container>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Card bg="light" text="light" className="mb-2 mt-4 shadow">
                        <Card.Header className="d-flex justify-content-between">
                            <Tabs
                                defaultActiveKey="files"
                                id="uncontrolled-tab-example"
                                onSelect={(key) => handleRelatedListTab(key)}
                            >
                                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(permission => {
                                    return userInfo?.permissions?.map(p => p.name).includes(permission);
                                }) &&
                                    <Tab eventKey="files" title="Files"></Tab>
                                }
                                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => {
                                    return userInfo?.permissions?.map(p => p.name).includes(permission);
                                }) &&
                                    <Tab eventKey="tasks" title="Tasks"></Tab>
                                }
                                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER].some(permission => {
                                    return userInfo?.permissions?.map(p => p.name).includes(permission);
                                }) &&
                                    <Tab eventKey="orders" title="Orders"></Tab>
                                }
                                {isAuthorized && (
                                    <Tab eventKey="quotation" title="Quotation Details"></Tab>
                                )}
                            </Tabs>


                            {(relatedListFiles && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_FILE].some(permission => {
                                return userInfo?.permissions?.map(p => p.name).includes(permission);
                            })) && (
                                    <Button
                                        size="sm"
                                        className="btn-custom float-right"
                                        onClick={() => setModalShowFile(true)}
                                    >
                                        New Files
                                    </Button>
                                )}

                            {(relatedListTaskList && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_TASK].some(permission => {
                                return userInfo?.permissions?.map(p => p.name).includes(permission);
                            })) && (
                                    <Button
                                        size="sm"
                                        className="btn-custom float-right"
                                        onClick={() => setModalShowTask(true)}
                                    >
                                        New Task
                                    </Button>
                                )}


                            {/* Modals */}
                            {modalShowFile && (
                                <FilesCreate
                                    show={modalShowFile}
                                    onHide={() => setModalShowFile(false)}
                                    parent={offer}
                                    table="medicaltest"
                                    submitFiles={submitFiles}
                                />
                            )}

                            {modalShowTask && (
                                <TaskEdit
                                    show={modalShowTask}
                                    onHide={() => setModalShowTask(false)}
                                    parentid={offer?.id}
                                    table="offer"
                                    submitTasks={submitTasks}
                                />
                            )}
                        </Card.Header>
                        <Card.Body>
                            {(relatedListFiles && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(permission => {
                                return userInfo?.permissions?.map(p => p.name).includes(permission);
                            })) && (
                                    <RelatedListFiles
                                        refreshFileList={refreshFileList}
                                        // onFileUpdate={updateCounter}
                                        parent={offer}
                                        submitFiles={submitFiles}
                                    />
                                )}

                            {(relatedListTaskList && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => {
                                return userInfo?.permissions?.map(p => p.name).includes(permission);
                            })) && (
                                    <RelatedListTask
                                        refreshTaskList={refreshTaskList}
                                        parent={offer}
                                        submitFiles={submitTasks}
                                        table="Lead"
                                    />
                                )}

                            {(relatedListOrder && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER].some(permission => {
                                return userInfo?.permissions?.map(p => p.name).includes(permission);
                            })) && (
                                    <RelatedListOrder
                                        refreshList={refreshOrderList}
                                        parent={offer}
                                        table="offer"
                                    />
                                )}

                            {isAuthorized && relatedListQuotation && (
                                <RelatedListQuotationDetails
                                    parent={offer}
                                    refreshList={refreshQuotationList}
                                />
                            )}
                        </Card.Body>
                    </Card>
                </>
            )}

        </Container>

    );
};
export default OfferView;
